import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import {formatPhone} from "helpers/phone";

class Header extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        page: PropTypes.oneOf(['conversation', 'notes', 'advert']),
    };

    render() {
        const {id, page} = this.props;
        return (
            <div className="row align-items-center topbar">
                {page === 'conversation' &&
                    <FormattedMessage id="conversations.header.conversation.title" defaultMessage="Conversation" children={(message) => (
                        <div className="col-12 text-center">
                            <h2 className="chat-h2">{message}</h2>
                        </div>
                    )}/>
                }

                {page === 'notes' &&
                <FormattedMessage id="conversations.header.notes.title" defaultMessage="Notes" children={(message) => (
                    <div className="col-12 text-center">
                        <h2 className="chat-h2">{message}</h2>
                    </div>
                )}/>
                }

                {page === 'advert' &&
                <FormattedMessage id="conversations.header.advert.title" defaultMessage="Advert" children={(message) => (
                    <div className="col-12 text-center">
                        <h2 className="chat-h2">{message}</h2>
                    </div>
                )}/>
                }

                {id && id !== '' &&
                <div className="col-12 text-center text-muted text-md-right">
                    <FormattedMessage id="conversation.edit_customer_info.id" defaultMessage="Phone number" />
                    <span>: {(/^(\+?\d+)/.test(id) ? formatPhone(id) : id)}</span>
                </div>
                }
            </div>
        )
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Header/Header.jsx